export default __webpack_public_path__ + "static/media/plurifonds_de.partner.icon.1a809a0c.svg";